module.exports = __webpack_public_path__ + "static/media/ninx1.f48f7ec5.jpg";